
<template>
  <div class="payrecordpage">
    <div class="payname">
      <div class="payname">
        <span>{{userinfo.Name}}</span>
        <span>{{userinfo.CardNumber}}</span>
        <span class="cor" @click="switchPerson">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="paytime">
      <span>就诊时间：</span>
      <span class="sel" @click="checkPickerOption">{{timeType}}</span>
    </div>
    <div class="recordernav">
      <span :class="{spancheck: currentCheck == 'all'}" @click="selectMenu('all')">全部</span>
      <span :class="{spancheck: currentCheck == 'failt'}" @click="selectMenu('failt')">待就诊</span>
      <span :class="{spancheck: currentCheck == 'success'}" @click="selectMenu('success')">完成就诊</span>
    </div>

    <div class="paydeteil" v-for="item in regSelectInfo" v-show="isShow">
      <div>
        <p class="pensontit">
          <img src="../../assets/images/penson.png" alt class="pensonpic">
          <span>{{item.PatName}}</span>
          <span>{{item.Code}}</span>
          <span class="fontblue" @click="recordDetil(item.GUID)">查看详情</span>
          <span class="smallicon">></span>
        </p>
        <div class="pd20">
          <p>
            <span>就诊科室：</span>
            <span>{{item.Dpt_Name}}</span>
          </p>
          <p>
            <span>就诊医生：</span>
            <span>{{item.Name}}</span>
          </p>
          <p>
            <span>就诊日期:</span>
            <span class="mr18">{{item.VisitDate | formatDate}}</span>
          </p>
          <span
            :class="item.State!=2?'statuspos statusred':'statuspos statusgray'"
          >{{item.StateName}}</span>
        </div>
      </div>
    </div>

    <div class="noDate" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
import { GetRegisterListByPatID } from "@/services/getData.js";
import weui from "weui.js";
import _ from "lodash";
import moment from "moment";
export default {
  name: "personal-record",
  data() {
    return {
      currentCheck: "all",
      userinfo: {},
      regInfo: {},
      regSelectInfo: {},
      timeType: "七天内",
      isShow: true
    };
  },
  created: function() {
    this.userinfo = this.$store.state.userInfo;
    this.getRegisterListByPatID();
  },
  methods: {
    checkPickerOption: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
          {
            label: "半年内",
            value: 2
          },
          {
            label: "不限时间",
            value: 3
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.timeType = result["0"]["label"];
            _that.getRegisterListByPatID(result["0"]["value"]);
          }
        }
      );
    },
    recordDetil(regID) {
      this.$router.push({
        name: "PersonalRecorddeteil",
        query: { regID: regID }
      });
    },
    switchPerson() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    getRegisterListByPatID(timeType) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetRegisterListByPatID(timeType).then(response => {
        loading.hide();
        if (response.data) {
          console.info(response.data);
          var regInfo = response.data;
          this.regInfo = regInfo;
          this.regSelectInfo = regInfo;
          this.selectMenu(this.currentCheck);
        } else {
        }
      });
    },
    selectMenu(state) {
      this.currentCheck = state;
      switch (state) {
        case "failt":
          this.regSelectInfo = _.filter(this.regInfo, function(item) {
            return item.State == 0;
          });
          break;
        case "success":
          this.regSelectInfo = _.filter(this.regInfo, function(item) {
            return item.State == 2;
          });
          break;
        case "all":
          this.regSelectInfo = this.regInfo;
          break;
      }
    }
  },
  filters: {
    formatDate: function(time) {
      return moment(time).format("YYYY-MM-DD");
    }
  }
};
</script>
<style>
.payrecordpage {
  width: 100%;
  height: auto;
}

.payrecordpage .payname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.payrecordpage .payname > div {
  position: relative;
}

.payrecordpage .payname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.payrecordpage .needle {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: -0.02rem;
}

.payrecordpage .recordernav {
  display: flex;
  flex-direction: row;
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  background: white;
  text-align: center;
}

.payrecordpage .recordernav > span {
  display: block;
  flex: 1;
}

.payrecordpage .borderadd {
  border-left: 1px solid rgba(229, 229, 229, 1);
  border-right: 1px solid rgba(229, 229, 229, 1);
}

.payrecordpage .spancheck {
  color: #1592e4;
  border-bottom: 0.04rem solid #1592e4;
}

.payrecordpage .paydeteil {
  background: white;
  padding: 0 0.2rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.36rem;
  margin-top: 0.2rem;
}

.payrecordpage .paydeteil .pensontit {
  border-bottom: 0.01rem solid rgba(221, 221, 221, 1);
  position: relative;
  box-sizing: border-box;
  padding-top: 0.2rem;
  padding-bottom: 0.18re;
  padding-bottom: 0.14rem;
}

.payrecordpage .paydeteil .pensontit .pensonpic {
  width: 0.22rem;
  height: 0.28rem;
  display: inline-block;
  vertical-align: text-top;
}

.payrecordpage .paydeteil .pensontit .fontblue {
  color: rgba(21, 146, 228, 1) !important;
  float: right;
  margin-right: 0.4rem;
}

.payrecordpage .paydeteil .pensontit .smallicon {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
}

.payrecordpage .paydeteil .pd20 {
  padding: 0.2rem 0;
  box-sizing: border-box;
  position: relative;
}

.mr18 {
  margin-left: 0.18rem;
}

.payrecordpage .statuspos {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.12rem;
}

.payrecordpage .statusred {
  color: red;
}

.payrecordpage .statusgreen {
  color: #579c53;
}

.payrecordpage .statusgray {
  color: #999999;
}

.payrecordpage .paytime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.payrecordpage .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}

.payrecordpage .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}
</style>




// WEBPACK FOOTER //
// src/components/person/personal-record.vue